(() => {
  const collectionMatch = location.pathname.match(/\/collections\/([^/]+)/);
  if (!collectionMatch) return;
  const collectionPath = location.pathname.slice(0, collectionMatch.index + collectionMatch[0].length);

  const contextualize = (link) => {
    if (!link.closest('#ProductGridContainer')) return null;

    const target = new URL(link.href, location.href);
    const productMatch = target.pathname.match(/\/products\/[^/]+/);
    if (target.origin !== location.origin || !productMatch) return null;
    if (/\/collections\/[^/]+\/products\//.test(target.pathname)) return target;

    target.pathname = `${collectionPath}${productMatch[0]}`;
    link.href = target.href;
    return target;
  };

  const contextualizeAll = (root) => {
    if (root.matches?.('a[href*="/products/"]')) contextualize(root);
    root.querySelectorAll?.('a[href*="/products/"]').forEach(contextualize);
  };

  contextualizeAll(document);
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) contextualizeAll(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const target = contextualize(link);
    if (!target) return;

    sessionStorage.setItem('thinkcar:breadcrumb-source', JSON.stringify({
      handle: decodeURIComponent(collectionMatch[1]),
      title: document.querySelector('h1')?.textContent.trim() || '',
      productPath: target.pathname.replace(/\/$/, '')
    }));
  }, true);
})();
